import { render } from "./RegisterMobileVerifyView.vue?vue&type=template&id=904ac77e"
import script from "./RegisterMobileVerifyView.vue?vue&type=script&lang=js"
export * from "./RegisterMobileVerifyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__